import { useParams } from 'react-router-dom'
import { useMemo } from 'react'
import { getOrgBySlug } from '../data/mock'

export default function useOrg() {
  const { slug } = useParams()

  const org = useMemo(() => {
    return getOrgBySlug(slug || '')
  }, [slug])

  return org
}
